import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

import LoadingSpinner from '../../../components/LoadingSpinner';

interface ImportDetailsHeaderEditModeProps {
  editedTitle: string;
  editedDescription: string;
  isUpdating: boolean;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

const ImportDetailsHeaderEditMode: React.FC<
  ImportDetailsHeaderEditModeProps
> = ({
  editedTitle,
  editedDescription,
  isUpdating,
  onTitleChange,
  onDescriptionChange,
  onSave,
  onCancel,
}) => {
  return (
    <div className='space-y-4'>
      {/* Title Input */}
      <div>
        <label
          htmlFor='edit-import-title'
          className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'
        >
          Title
        </label>
        <input
          id='edit-import-title'
          type='text'
          value={editedTitle}
          onChange={e => onTitleChange(e.target.value)}
          placeholder='e.g., March 2024 Office Expenses'
          className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
        />
      </div>

      {/* Description Textarea */}
      <div>
        <label
          htmlFor='edit-import-description'
          className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'
        >
          Description
        </label>
        <textarea
          id='edit-import-description'
          value={editedDescription}
          onChange={e => onDescriptionChange(e.target.value)}
          placeholder='Add a description...'
          rows={3}
          className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none'
        />
      </div>

      {/* Action Buttons */}
      <div className='flex items-center space-x-2'>
        <button
          onClick={onSave}
          disabled={isUpdating}
          className='flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 text-sm font-medium'
        >
          {isUpdating ? (
            <>
              <LoadingSpinner color='border-white' className='-ml-1 mr-2' />
              Saving...
            </>
          ) : (
            <>
              <CheckIcon className='w-4 h-4 mr-2' />
              Save
            </>
          )}
        </button>
        <button
          onClick={onCancel}
          disabled={isUpdating}
          className='flex items-center px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 text-sm font-medium'
        >
          <XMarkIcon className='w-4 h-4 mr-2' />
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ImportDetailsHeaderEditMode;
